import { ReportFormat } from "@common/helpers/reports";
import { ReportSettingRowVisibility } from "@common/types/reports/report-settings";

export function pickXlsxExportRowVisibility(
    format: ReportFormat,
    rowVisibility?: ReportSettingRowVisibility,
): ReportSettingRowVisibility | undefined {
    return format === ReportFormat.XLSX ? rowVisibility : undefined;
}
